export default (params) => ({
  trigger: {
    name: 'segment_navigation.open_menu',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'open_menu',
      params: {
        sub_feature: null,
      },
    },
    nonInt: false,
  },
});
